import { useState, useEffect} from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Flex,
  Button,
  useToast,
  Spinner,
  Text,
  Divider,
  Box,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useUserContext } from "context/UserContext";
import FormikSelect from "components/formikSelect";
import FormikTextArea from "components/formikTextArea";
import useAddRequest from "api/mutations/useAddRequest";
import useGetRequestTypes from "api/queries/useGetRequestTypes";

const MakeARequestModal = ({ isOpen, onClose }) => {
  const toast = useToast();
  const { user } = useUserContext();
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);

  const requestTypesQuery = useGetRequestTypes();

  const formik = useFormik({
    initialValues: {
      request_type: "",
      description: "",
      requested_by: user?.info?._id,
    },
    validationSchema: Yup.object({
      request_type: Yup.string().required("Request type is required"),
      description: Yup.string(),
    }),
    onSubmit: (values) => addRequest(values),
  });

  const addRequestMutation = useAddRequest({
    onSuccess: (res) => {
      formik.resetForm();
      onClose();
    },
    onError: (err) => {
      console.log(err);
      toast({
        title: "Failed to send request",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    },
  });

  useEffect(() => {
    if (!formik.values["description"]) {
      setIsSaveDisabled(true);
      return;
    }

    setIsSaveDisabled(false);
  }, [formik.values]);

  const addRequest = (values) => {
    addRequestMutation.mutate(values);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={true}>
      <ModalOverlay />
      <ModalContent minH={"300px"} minW={"800px"} p={4} borderRadius={"16px"}>
        <ModalBody display={"flex"} flexDirection={"column"} gap={4}>
          <Text
            color={"#000000"}
            fontFamily="PlusJakartaSansSemiBold"
            fontSize={"24px"}
            lineHeight={"32px"}
            textTransform={"capitalize"}
          >
            Make A Request
          </Text>
          <Divider />
          <Box>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansSemiBold"
              fontSize={"16px"}
              lineHeight={"22px"}
              textTransform={"capitalize"}
              mb={2}
            >
              Request Details
            </Text>
            <Box border="1px solid #D9D9D9" borderRadius="8px" p={4}>
              <FormikSelect
                formik={formik}
                name="request_type"
                label={"Type"}
                labelColor={"black"}
                style={{
                  marginBottom: 20,
                }}
                placeholder={"Select Request Type"}
              >
                {requestTypesQuery?.data?.data?.map((requestType) => (
                  <option key={requestType?._id} value={requestType?.type}>
                    {requestType?.type}
                  </option>
                ))}
              </FormikSelect>
              <FormikTextArea
                formik={formik}
                name="description"
                label={"Description"}
                labelColor={"black"}
              />
            </Box>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Flex w={"100%"} justify={"end"} gap={4}>
            <Button
              bg={"transparent"}
              border={"1px solid #000000"}
              color="#000000"
              size="12px"
              borderRadius="12px"
              fontFamily="PlusJakartaSansMedium"
              w={"174px"}
              h={"40px"}
              textTransform={"uppercase"}
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              bg="#000000"
              borderRadius="12px"
              color="#FFFFFF"
              size="12px"
              fontFamily="PlusJakartaSansMedium"
              w={"174px"}
              h={"40px"}
              textTransform={"uppercase"}
              onClick={formik.handleSubmit}
              isDisabled={isSaveDisabled || addRequestMutation.isLoading}
            >
              {addRequestMutation.isLoading ? <Spinner /> : "Save"}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default MakeARequestModal